// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import LoadingOutlinedSvg from "@fishx/icons-svg/es/asn/LoadingOutlined";
import FishxIcon from '../components/FishxIcon';

var LoadingOutlined = function LoadingOutlined(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: LoadingOutlinedSvg
  }));
};

LoadingOutlined.displayName = 'LoadingOutlined';
export default React.forwardRef(LoadingOutlined);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/LoadingOutlined.js
// module id = 3064
// module chunks = 0